import _ActivityTracker from './ActivityTracker';

const ActivityTracker = _ActivityTracker;

export default ActivityTracker;



// WEBPACK FOOTER //
// ./src/components/ActivityTracker/index.js